module.exports = __webpack_public_path__ + "img/sync2-logo.cf3878b5.svg";